import axios from './_nestAxios'

export const getMarca = _id => axios.get(`/marcas/${_id}`)

export const getMarcas_Select = () =>
  axios.get('/marcas', {
    params: {
      tipoConsulta: 'select'
    }
  })

export const insertarMarca = data => axios.post('/marcas/nuevo', data)

export const actualizarMarca = (_id, data) => axios.put(`/marcas/${_id}`, data)

export const eliminarMarca = _id => axios.delete(`/marcas/${_id}`)
